import React from "react";
import { observable, toJS } from "mobx";
import {montarSelectOption} from "../../../utils/formatar";

export default class FiltrosCargaGeralStore { 

    // Area de inclusão 
    @observable inserindo;
    @observable inserindoXml;
    @observable filtroNavio;
    @observable filtros;
    @observable situacoesFiltros;
    @observable filtroSituacao;
    @observable filtroUtilizado;
    @observable situacoesFiltrosUtilizado;


    constructor(service) { 
        // Area de inclusão
        this.filtroUtilizado = false;
        this.situacoesFiltrosUtilizado =false;
        this.inserindo = false;
        this.salvando = false;
        this.situacoesFiltros = false;
        this.inserindoXml = false;
        this.filtroNavio = false;
        this.filtroSituacao = false;
        this.filtros = {
            placa: null, cpf: null, cnh: null, status: null, utilizado: null
        };
        this.carregarFiltros();
        this.carregarFiltrosUtilizado();
    }

    carregarFiltros = () => {
        
                this.situacoesFiltros = montarSelectOption("Codigo","Status", [
                    { Codigo: "Liberado", Status: 'Liberado' },
                    { Codigo: "Inativado", Status: 'Inativado' },
                    { Codigo: "No show", Status: 'No show' },
                    { Codigo: "Concluido", Status: 'Concluido' }
                ]);

    };

    carregarFiltrosUtilizado = () => {
        
        this.situacoesFiltrosUtilizado = montarSelectOption("Codigo","Utilizado", [
            { Codigo: "Sim", Utilizado: 'Sim' },
            { Codigo: "Nao", Utilizado: 'Não' },
        ]);

};

    onChangeFiltroNavios = value => {
        this.filtroNavio = value!==null ? value : false;
    };

    onChangeFiltroSituacao = value => {
        this.filtroSituacao = value!==null ? value : false;
    };

    onChangeFiltroUtilizado = value => {
        this.filtroUtilizado = value!==null ? value : false;
    };


    onChangeFiltro = (dado, event) => {
        if (event) {
            _.set(this.filtros, dado, event.target.value);
        } else {
            _.set(this.filtros, dado, null);
        }
    };

}



// WEBPACK FOOTER //
// ./src/modules/carga-geral/stores/FiltrosCargaGeralStore.js